import React from 'react';
import './styles.css';

interface Props {
  color?: string;
}

const Spin: React.FC<Props> = ({ color = '#00b1f1' }) => {
  return (
    <div className="main">
      <div className="lds-ellipsis">
        <div style={{ backgroundColor: color }}></div>
        <div style={{ backgroundColor: color }}></div>
        <div style={{ backgroundColor: color }}></div>
        <div style={{ backgroundColor: color }}></div>
      </div>
    </div>
  );
};

export default Spin;
